/**
 * Application initialization utilities
 *
 * This module provides initialization functions that set up global
 * application state like locale without creating framework dependencies.
 */

import { initializeLocale } from '../Common/Helpers/locale';

/**
 * Initialize application with Inertia page props
 * Call this in your main application setup
 */
export const initializeApp = (props?: any): void => {
    // Extract locale from Inertia props if available
    const locale =
        props?.locale || props?.app?.locale || (typeof window !== 'undefined' ? document.documentElement.lang : null);

    initializeLocale(locale);
};

/**
 * Initialize application from usePage() without creating dependency
 * This can be called from components that already use Inertia
 */
export const initializeAppFromPage = (page: any): void => {
    const locale = page?.props?.locale || page?.props?.app?.locale;

    initializeLocale(locale);
};

/**
 * Update locale when it changes
 * Call this when user changes language preference
 */
export const updateAppLocale = (newLocale: string): void => {
    initializeLocale(newLocale);
};
